import React, { PropsWithChildren } from 'react'
import { useWizard } from './Wizard'

type WizardStepProps = PropsWithChildren<{
  step: number
}>

export const WizardStep = ({ step, children }: WizardStepProps) => {
  const { activeStep } = useWizard()

  if (activeStep !== step) {
    return null
  }

  return <>{children}</>
}
